import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { GeneralityHeader, LoaderModal } from './GeneralityComponent';
import '../orders/Order.css';
import { NewsletterApi } from '../../app/api/newsletter.api';


export function Newsletter() 
{
  const newsletter = NewsletterApi(); 

  const [showLoader, setShowLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [month, setMonth] = useState("");
      
  const fetchData = async () => { 
    const {data} = await newsletter.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["newsletters"], queryFn: fetchData });
      

  useEffect(() => {
      
      if (!Array.isArray(data)) return;
      let filtered = data;

      // Filtre mois (format YYYY-MM)
      if (month !== "") {
        filtered = filtered.filter(item =>
          item.createdAt?.startsWith(month)
        );
      }
         
      setFilteredData(filtered);
      
  }, [data, month]);  



  const handleDownload = async () => {

  setShowLoader(true);
  try {

    const response = await newsletter.getFile(); // resType: "blob"

    // Création du blob
    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;"
    });

    // Création du lien temporaire
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "newsletters.csv");

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.log(err);

  } finally {
    setShowLoader(false);

  }
};



  return (

    <Layout activeMenu={5}>
  
      <div className='container-fluid'>
        <div className='row justify-content-center pt-4'>
          <div className='col-md-11'>
                
            <section className='row' >
              <GeneralityHeader active={2} />
            </section>

            <section className='row'> 
                <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                   {/* Vue Grille/Liste */}
                   <div className="d-flex align-items-center gap-3 display-controls">
                     <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                     <span className="text-muted lead"> Liste des messages </span>
                   </div>
                    {/* Infos et Tris */}
                   <div className="d-flex align-items-center gap-3 filter-controls">
                      <span className="text-muted small"> { filteredData.length } effectif(s) </span>
                   </div>
                   <button title="Ajouter un produit" className="btn btn-sm btn-outline-green px-3" onClick={ handleDownload }>
                     <i className="bi bi-download me-1"> </i> Télécharger
                   </button>
                </div>

                {/* Boutons de Filtres Catégories */}
                <div className="d-flex gap-2 flex-wrap mb-5">
                  <div className="d-flex align-items-center">
                    <span className="text-muted px-3 bg-light border py-1"> <i className="bi bi-funnel"> </i> </span>
                    <input type="month" className="w-100 px-3 py-1 border" value={month} name="month" onChange={ e => setMonth(e.target.value) } />         
                  </div>
                </div>
            </section>

            {/* ________________ MESSAGE ________________ */}

            <section className="row mb-4">

              {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="spinner-border mb-3" style={{ width: '5rem', height: '5rem', color: '#307072' }}></div>
                  <p className="text-secondary"> Chargement de données en cours...</p>
                </div>
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                filteredData.map( ( item, index ) => (

                    <div className="col-lg-12 px-0" key={index}>
                        <div className="d-flex gap-3 px-3 py-2 bg-light  border mb-3">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center text-green me-2 pe-3">
                                <i className="bi bi-star lead"> </i> 
                            </div>
                            <div>
                              <div className="text-secondary fw-bold small" title={ 'email' }> { item?.email } </div>
                              <div className="text-secondary small" title={ 'date' }> { item?.createdAt } </div>
                            </div>
                          </div>
                        </div>
                    </div>
                 ))
              )} 

              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}

            </section>

          </div>   
        </div>
      </div>

      {/* Loader popup */}
      <LoaderModal show={ showLoader }  />
      

    </Layout>

  );
        
}